import { apiGetCached } from "../utils/api";

const LEAGUES_ENDPOINT = "/api/leagues/";
const LEAGUES_TTL_MS = 5 * 60 * 1000;

export const getLeagues = async ({ force = false } = {}) => {
  const response = await apiGetCached(
    LEAGUES_ENDPOINT,
    {},
    { force, ttlMs: LEAGUES_TTL_MS, cacheKey: LEAGUES_ENDPOINT }
  );
  return Array.isArray(response.data) ? response.data : [];
};
